/**
 * Pure presentation helpers for the unified model catalog (Track B-4).
 * Kept Flutter/React-free so they unit-test without rendering.
 */

import type { BillingDescriptor, Modality } from '@/types';

const num = (v: number | null | undefined): string => (v == null ? '-' : String(v));

/** One-line price summary for any billing descriptor. */
export function formatBilling(b: BillingDescriptor): string {
  switch (b.billing_mode) {
    case 'per_token': {
      let s = `${num(b.input_per_million)} / ${num(b.output_per_million)} per 1M ${b.currency}`;
      if (b.cache_read_per_million != null || b.cache_write_per_million != null) {
        s += ` (cache ${num(b.cache_read_per_million)} / ${num(b.cache_write_per_million)})`;
      }
      return s;
    }
    case 'per_image':
      return `${num(b.cost_per_image)} / image ${b.currency}`;
    case 'per_character':
      return `${num(b.cost_per_1k_chars)} / 1K chars ${b.currency}`;
    case 'per_second':
      return `${num(b.cost_per_minute)} / min ${b.currency}`;
    case 'free':
      return 'Free';
  }
}

const MODALITY_LABELS: Record<Modality, string> = {
  text: 'Text / LLM',
  image: 'Image',
  tts: 'TTS',
  stt: 'STT',
  embedding: 'Embedding',
  rerank: 'Rerank',
  realtime: 'Realtime',
};

export function modalityLabel(m: Modality): string {
  return MODALITY_LABELS[m] ?? m;
}
